import {
  all,
  call,
  fork,
  put,
  takeLatest,
  takeLeading,
} from 'redux-saga/effects';
import { toastError } from 'src/common/helpers/Notifications';
import { setUserInfo } from 'src/common/helpers/StorageUtils';
import ApiConstants from '../../helpers/ApiConstants';
import * as requests from '../../helpers/HTTPRequest';
import * as Actions from './actions';

function* fetchDeviceAlarmSettings() {
  try {
    const url = `${ApiConstants.BASE_URL}${ApiConstants.DEVICE_ALARM_SETTINGS}`;
    const apiRes = yield call(requests.getRequest, url, {});

    yield put(Actions.fetchDeviceAlarmSettingsSuccess(apiRes));
  } catch (e) {
    console.log(e);
    toastError(e.message);
    yield put(Actions.fetchDeviceAlarmSettingsError());
  }
}

function* updateDeviceAlarmSettings({ payload }) {
  try {
    const url = `${ApiConstants.BASE_URL}${ApiConstants.DEVICE_ALARM_SETTINGS}`;
    const { params, callback } = payload;
    const apiRes = yield call(requests.putRequest, url, params);

    // Save device alarm settings on local
    localStorage.setItem('DEVICE_ALARM_SETTINGS', JSON.stringify(apiRes));

    yield put(Actions.updateDeviceAlarmSettingsSuccess(apiRes));
    callback && callback();
  } catch (e) {
    console.log(e);
    toastError(e.message);
    yield put(Actions.updateDeviceAlarmSettingsError());
  }
  // finally {
  //   yield delay(1000);
  //   yield put(Actions.updateDeviceAlarmSettingsResetState());
  // }
}

function* getUserProfileSaga({ callback }) {
  try {
    const url = `${ApiConstants.BASE_URL}${ApiConstants.PROFILE}`;
    const response = yield call(requests.getRequest, url, {});
    yield put({
      type: Actions.userActions.GET_USER_PROFILE_SUCCESS,
      payload: response,
    });

    setUserInfo(response);

    callback?.();
  } catch (e) {
    console.log(e);
    toastError(e.message);
    yield put({
      type: Actions.userActions.GET_USER_PROFILE_ERROR,
    });
  }
}

export function* watchUser() {
  yield takeLeading(
    Actions.userActions.FETCH_DEVICE_ALARM_SETTING,
    fetchDeviceAlarmSettings
  );
  yield takeLeading(
    Actions.userActions.UPDATE_DEVICE_ALARM_SETTING,
    updateDeviceAlarmSettings
  );
  yield takeLatest(Actions.userActions.GET_USER_PROFILE, getUserProfileSaga);
}

export default function* rootSaga() {
  yield all([fork(watchUser)]);
}
